import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Navbar';
import '../../components/Navbar.css';
import AdminSidebar from '../../components/AdminSidebar';
import { getToken } from '../../utils/auth';
import { useParams, useNavigate } from 'react-router-dom';

function CandidateEdit() {
  const { acctNum } = useParams();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [voterId, setVoterId] = useState('');
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const token = getToken();
      const res = await fetch('/api/candidates/' + acctNum, { headers: { 'x-auth-token': token } });
      if (res.ok) {
        const d = await res.json();
        setData(d);
        // populate voterId field from common names
        setVoterId(d.VoterID ?? d.VoterId ?? d.Voter ?? '');
      }
      setLoading(false);
    };
    fetchData();
  }, [acctNum]);

  if (loading) return <div>Loading...</div>;

  if (!data) return <div>Candidate not found</div>;

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <Navbar />
      <div style={{ display: 'flex', maxWidth: '1200px', margin: '12px auto' }}>
        <AdminSidebar />
        <main style={{ flex: 1, padding: 12 }}>
          <h2>Edit Candidate {acctNum}</h2>
          {/* Simple edit form for VoterID */}
          <div style={{ marginBottom: 12 }}>
            <label style={{ display: 'block', marginBottom: 6 }}>VoterID</label>
            <input
              type="text"
              value={voterId}
              onChange={e => setVoterId(e.target.value)}
              style={{ padding: 8, width: 300 }}
            />
          </div>
          <div style={{ marginBottom: 12 }}>
            <button
              className="btn btn-primary"
              onClick={async () => {
                setSaving(true);
                setMessage(null);
                try {
                  const token = getToken();
                  const payload = { VoterID: voterId };
                  const res = await fetch('/api/admin/candidates/' + acctNum, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json', 'x-auth-token': token },
                    body: JSON.stringify(payload)
                  });
                  if (!res.ok) {
                    const err = await res.json().catch(() => ({}));
                    throw new Error(err.msg || 'Update failed');
                  }
                  const updated = await res.json();
                  setData(updated);
                  setMessage('Saved');
                } catch (err) {
                  setMessage('Error: ' + err.message);
                } finally {
                  setSaving(false);
                }
              }}
              disabled={saving}
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
            <button style={{ marginLeft: 8 }} onClick={() => navigate(-1)}>Back</button>
          </div>
          {message && <div style={{ marginTop: 8 }}>{message}</div>}

          {/* Also show the raw JSON below the form for reference */}
          <h3 style={{ marginTop: 18 }}>Raw record</h3>
          <pre style={{ whiteSpace: 'pre-wrap', background: '#f6f6f6', padding: 12, borderRadius: 4 }}>{JSON.stringify(data, null, 2)}</pre>
        </main>
      </div>
    </div>
  );
}

export default CandidateEdit;
